(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("matic", [], factory);
	else if(typeof exports === 'object')
		exports["matic"] = factory();
	else
		root["matic"] = factory();
})(self, () => {
return 